// extracted by mini-css-extract-plugin
export default {"items":"itemsGrid_items__SUMRU","search":"itemsGrid_search__ERkjK"};